export interface Review {
  id: string;
  name: string;
  location: string;
  role: string;
  rating: number;
  content: string;
  avatarColor: string;
  date: string;
}

export const reviews: Review[] = [
  {
    id: 'rev-1',
    name: '张大山',
    location: '山东寿光',
    role: '黄瓜种植大户（30亩大棚）',
    rating: 5,
    content: '在黄瓜网站上学习了霜霉病综合防治方案，去年按照方案操作，发病率下降了70%以上，产量比前年提高了将近两成。特别是病害识别图解非常实用，现在一看就知道是什么病。强烈推荐给所有种黄瓜的朋友！',
    avatarColor: 'bg-accent-500',
    date: '2026-07-15',
  },
  {
    id: 'rev-2',
    name: '李美玲',
    location: '河北保定',
    role: '蔬菜经销商',
    rating: 5,
    content: '作为一个做蔬菜批发的，市场行情板块是我每天必看的。价格数据更新及时准确，分析也很专业。上个月参考了平台的价格走势预测，成功避开了价格低谷，多赚了不少。真心感谢这个平台！',
    avatarColor: 'bg-primary-500',
    date: '2026-07-10',
  },
  {
    id: 'rev-3',
    name: '王建国',
    location: '辽宁沈阳',
    role: '农业技术推广员',
    rating: 5,
    content: '平台上的种植技术文章专业性强、接地气，非常适合基层农技推广使用。我已经推荐给了我们区30多家黄瓜种植户，大家反馈都很好。品种推荐板块尤其受欢迎，帮大家选对了品种。',
    avatarColor: 'bg-secondary-500',
    date: '2026-07-05',
  },
  {
    id: 'rev-4',
    name: '赵小梅',
    location: '云南昆明',
    role: '新农人创业者',
    rating: 4,
    content: '作为一个刚入行的黄瓜种植新人，黄瓜网站就是我的线上老师。从种子怎么选到怎么施肥、怎么防病，都有详细讲解。用了平台推荐的水果黄瓜品种，效益比传统品种好很多。',
    avatarColor: 'bg-accent-400',
    date: '2026-06-28',
  },
];

export interface Stat {
  value: string;
  label: string;
}

export const stats: Stat[] = [
  { value: '50万+', label: '月活跃用户' },
  { value: '180+', label: '黄瓜品种收录' },
  { value: '2000+', label: '技术文章' },
  { value: '35个', label: '覆盖省市' },
];

export interface Partner {
  name: string;
  type: string;
}

export const partners: Partner[] = [
  { name: '中国农业科学院蔬菜花卉研究所', type: '科研合作单位' },
  { name: '山东省农业科学院', type: '技术指导单位' },
  { name: '寿光蔬菜产业集团', type: '战略合作伙伴' },
  { name: '全国农业技术推广服务中心', type: '行业合作单位' },
  { name: '北京新发地农产品批发市场', type: '数据合作单位' },
  { name: '中国蔬菜协会', type: '行业协作伙伴' },
];